
/*@jsxRuntime automatic @jsxImportSource react*/
export const attributes = {
  "authors": ["chase-merlin", "ben-milne"],
  "callToAction": {
    "heading": "Get started",
    "subheading": "Issue an ecosystem native stablecoin",
    "button": "Schedule time",
    "ctaUrl": "/contact",
    "externalUrl": true
  },
  "coverImage": {
    "alt": "Stablecoin token standards on leading blockchains | Brale Blog",
    "url": "/assets/blog/stablecoin-token-standards-on-leading-blockchains/cover.svg"
  },
  "date": "2024-08-20",
  "description": "Brale enables projects to issue stablecoins on 12+ blockchains. Learn more about stablecoin token standards on Ethereum, Solana, and emerging blockchains.",
  "discussLinkedIn": "https://www.linkedin.com/posts/brale_stablecoin-token-standards-on-leading-blockchains-activity-7231685341873598464-0z0L/",
  "discussTwitter": "https://x.com/brale_xyz/status/1825920577569198433",
  "discussFarcaster": "https://warpcast.com/brale/0x83c298d8",
  "excerpt": "An overview of stablecoin token standards on leading blockchains. We're building Brale to support stablecoin standards on all leading blockchains.",
  "ogImage": {
    "alt": "Stablecoin token standards on leading blockchains | Brale Blog",
    "url": "/assets/blog/stablecoin-token-standards-on-leading-blockchains/og-image.png"
  },
  "timeOverride": 3,
  "title": "Stablecoin token standards on leading blockchains",
  "evmStandards": [{
    "chainId": "arbitrum",
    "name": "Arbitrum",
    "tokenStandard": "ERC-20",
    "url": "https://ethereum.org/en/developers/docs/standards/tokens/erc-20/",
    "type": "Standard Interface",
    "braleSupported": "Yes"
  }, {
    "chainId": "avalanche",
    "name": "Avalanche",
    "tokenStandard": "ERC-20",
    "url": "https://ethereum.org/en/developers/docs/standards/tokens/erc-20/",
    "type": "Standard Interface",
    "braleSupported": "Yes"
  }, {
    "chainId": "base",
    "name": "Base",
    "tokenStandard": "ERC-20",
    "url": "https://ethereum.org/en/developers/docs/standards/tokens/erc-20/",
    "type": "Standard Interface",
    "braleSupported": "Yes"
  }, {
    "chainId": "bnb",
    "name": "BNB Chain",
    "tokenStandard": "BEP-20",
    "url": "https://github.com/bnb-chain/BEPs/blob/master/BEPs/BEP20.md",
    "type": "Standard Interface"
  }, {
    "chainId": "celo",
    "name": "Celo",
    "tokenStandard": "ERC-20",
    "url": "https://ethereum.org/en/developers/docs/standards/tokens/erc-20/",
    "type": "Standard Interface",
    "braleSupported": "Yes"
  }, {
    "chainId": "ethereum",
    "name": "Ethereum",
    "tokenStandard": "ERC-20",
    "url": "https://ethereum.org/en/developers/docs/standards/tokens/erc-20/",
    "type": "Standard Interface",
    "braleSupported": "Yes"
  }, {
    "chainId": "ethereum-classic",
    "name": "Ethereum Classic",
    "tokenStandard": "ERC-20",
    "url": "https://ethereum.org/en/developers/docs/standards/tokens/erc-20/",
    "type": "Standard Interface",
    "braleSupported": "Yes"
  }, {
    "chainId": "optimism",
    "name": "Optimism",
    "tokenStandard": "ERC-20",
    "url": "https://ethereum.org/en/developers/docs/standards/tokens/erc-20/",
    "type": "Standard Interface",
    "braleSupported": "Yes"
  }, {
    "chainId": "polygon",
    "name": "Polygon",
    "tokenStandard": "ERC-20",
    "url": "https://ethereum.org/en/developers/docs/standards/tokens/erc-20/",
    "type": "Standard Interface",
    "braleSupported": "Yes"
  }, {
    "chainId": "tron",
    "url": "https://developers.tron.network/docs/trc20-protocol-interface",
    "name": "Tron",
    "tokenStandard": "TRC-20",
    "type": "Standard Interface"
  }],
  "nonEvmStandards": [{
    "chainId": "solana",
    "name": "Solana",
    "tokenStandard": "SPL Token, Token 2022",
    "url": "https://spl.solana.com/token",
    "type": "Integrated Program",
    "braleSupported": "Yes"
  }, {
    "chainId": "stellar",
    "name": "Stellar",
    "tokenStandard": "Stellar Asset Contract (CAP-0046)",
    "url": "https://developers.stellar.org/docs/tokens/stellar-asset-contract",
    "type": "Integrated Program",
    "braleSupported": "Yes"
  }, {
    "chainId": "bitcoin",
    "name": "Bitcoin",
    "tokenStandard": "BRC-20, SRC-20, Runes",
    "type": "Standard Interface"
  }, {
    "chainId": "polkadot",
    "name": "Polkadot",
    "tokenStandard": "Assets Pallet (PSP-22)",
    "url": "https://github.com/w3f/PSPs/blob/master/PSPs/psp-22.md",
    "type": "Integrated Program",
    "braleSupported": "In Dev"
  }, {
    "chainId": "cosmos",
    "name": "Cosmos",
    "tokenStandard": "CW20",
    "url": "https://github.com/CosmWasm/cw-plus/blob/main/packages/cw20/README.md",
    "type": "Standard Interface",
    "braleSupported": "In Dev"
  }, {
    "chainId": "xrp",
    "name": "XRP Ledger",
    "tokenStandard": "XRP Fungible Token",
    "url": "https://www.notion.so/Stablecoin-Token-Standards-6cff9ebdb2bb4c148fbe0f8e48b41999?pvs=4",
    "type": "Integrated Program"
  }, {
    "chainId": "ton",
    "name": "TON",
    "tokenStandard": "Jetton Standard (TEP-74)",
    "url": "https://docs.ton.org/develop/dapps/defi/tokens#:~:text=Jetton%20Deployer%E2%80%8B,%E2%80%94%20WebClient%20(React%2C%20TypeScript)",
    "type": "Standard Interface"
  }, {
    "chainId": "aptos",
    "name": "Aptos",
    "tokenStandard": "Aptos Fungible Token",
    "url": "https://aptos.dev/en/build/smart-contracts/fungible-asset",
    "type": "Integrated Program"
  }, {
    "chainId": "sui",
    "name": "Sui",
    "tokenStandard": "Coin Standard",
    "url": "Coin Standard",
    "type": "Integrated Program"
  }, {
    "chainId": "hedera",
    "name": "Hedera",
    "tokenStandard": "Hedera Token Service (HTS)",
    "url": "https://hedera.com/token-service",
    "type": "Integrated Program",
    "braleSupported": "Yes"
  }, {
    "chainId": "canton",
    "name": "Canton Network",
    "tokenStandard": "Asset Model",
    "url": "https://www.notion.so/Stablecoin-Token-Standards-6cff9ebdb2bb4c148fbe0f8e48b41999?pvs=4",
    "type": "Integrated Program",
    "braleSupported": "Yes"
  }, {
    "chainId": "stacks",
    "name": "Stacks",
    "tokenStandard": "SIP-010",
    "url": "https://github.com/stacksgov/sips/blob/main/sips/sip-010/sip-010-fungible-token-standard.md",
    "type": "Standard Interface"
  }, {
    "chainId": "tezos",
    "name": "Tezos",
    "tokenStandard": "FA1.2",
    "url": "https://www.notion.so/Stablecoin-Token-Standards-6cff9ebdb2bb4c148fbe0f8e48b41999?pvs=4",
    "type": "Standard Interface"
  }, {
    "chainId": "cardano",
    "name": "Cardano",
    "tokenStandard": "Native Tokens",
    "url": "https://docs.cardano.org/developer-resources/native-tokens/",
    "type": "Standard Interface"
  }]
};
import {BlockchainIcon} from "~/components/logos/blockchain";
import {ExternalLink} from "~/components/site/external-link";
import {faArrowUpRight, faCircleCheck, faCircleHalfStroke, faHyphen} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h2: "h2",
    tr: "tr",
    td: "td",
    div: "div",
    span: "span"
  }, props.components);
  return <><_components.p>{"Each blockchain ecosystem has its own unique way of representing and managing stablecoin tokens. In this post, we've summarized the key fungible token standards across leading blockchains and highlighted where Brale supports these standards."}</_components.p>{"\n"}<_components.h2>{"EVM-compatible blockchains"}</_components.h2>{"\n"}<div className="border border-primary round overflow-x-scroll bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto text-base m-0"><thead><tr><th className="px-4 w-1/4">{"Blockchain"}</th><th className="px-4 w-1/4 whitespace-nowrap">{"Token Standard"}</th><th className="px-4 w-1/4">{"Type"}</th><th className="px-4 w-1/4 whitespace-nowrap">{"Brale Supported"}</th></tr></thead><tbody>{attributes.evmStandards.sort((a, b) => a.name.localeCompare(b.name)).map(s => <_components.tr key={s.chainId}>
            <_components.td className="px-4 whitespace-nowrap align-middle">
              <_components.div className="flex items-center gap-x-2">
                <BlockchainIcon chainId={s.chainId} className="h-6 w-6" />
                <_components.span>{s.name}</_components.span>
              </_components.div>
            </_components.td>
            <_components.td className="px-4 whitespace-nowrap align-middle">
              <_components.div className="flex items-center gap-x-2">
                {s.url ? <ExternalLink title="View token standard" href={s.url} className="flex items-center gap-x-1">
                    <_components.span>{s.tokenStandard}</_components.span>
                    <FontAwesomeIcon className="h-4 w-4 text-secondary align-middle" icon={faArrowUpRight} />
                  </ExternalLink> : <_components.span>{s.tokenStandard}</_components.span>}
              </_components.div>
            </_components.td>
            <_components.td className="px-4 whitespace-nowrap">{s.type}</_components.td>
            <_components.td className="px-4 whitespace-nowrap align-middle">
              {s.braleSupported === "Yes" ? <FontAwesomeIcon className="h-6 w-6 text-green-500 align-middle" icon={faCircleCheck} /> : s.braleSupported === "In Dev" ? <_components.div className="flex items-center gap-x-2">
                  <FontAwesomeIcon className="h-6 w-6 text-yellow-500 align-middle" icon={faCircleHalfStroke} />
                  <_components.span>{s.braleSupported}</_components.span>
                </_components.div> : <FontAwesomeIcon className="h-6 w-6 text-gray-300 dark:text-gray-700 align-middle" icon={faHyphen} />}
            </_components.td>
          </_components.tr>)}</tbody></table></div>{"\n"}<_components.h2>{"Non-EVM blockchains"}</_components.h2>{"\n"}<div className="border border-primary round overflow-x-scroll bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto text-base m-0"><thead><tr><th className="px-4 w-1/4">{"Blockchain"}</th><th className="px-4 w-1/4 whitespace-nowrap">{"Token Standard"}</th><th className="px-4 w-1/4">{"Type"}</th><th className="px-4 w-1/4 whitespace-nowrap">{"Brale Supported"}</th></tr></thead><tbody>{attributes.nonEvmStandards.sort((a, b) => a.name.localeCompare(b.name)).map(s => <_components.tr key={s.chainId}>
            <_components.td className="px-4 whitespace-nowrap align-middle">
              <_components.div className="flex items-center gap-x-2">
                <BlockchainIcon chainId={s.chainId} className="h-6 w-6" />
                <_components.span>{s.name}</_components.span>
              </_components.div>
            </_components.td>
            <_components.td className="px-4 whitespace-nowrap align-middle">
              <_components.div className="flex items-center gap-x-2">
                {s.url ? <ExternalLink title="View token standard" href={s.url} className="flex items-center gap-x-1">
                    <_components.span>{s.tokenStandard}</_components.span>
                    <FontAwesomeIcon className="h-4 w-4 text-secondary align-middle" icon={faArrowUpRight} />
                  </ExternalLink> : <_components.span>{s.tokenStandard}</_components.span>}
              </_components.div>
            </_components.td>
            <_components.td className="px-4 whitespace-nowrap">{s.type}</_components.td>
            <_components.td className="px-4 whitespace-nowrap align-middle">
              {s.braleSupported === "Yes" ? <FontAwesomeIcon className="h-6 w-6 text-green-500 align-middle" icon={faCircleCheck} /> : s.braleSupported === "In Dev" ? <_components.div className="flex items-center gap-x-2">
                  <FontAwesomeIcon className="h-6 w-6 text-yellow-500 align-middle" icon={faCircleHalfStroke} />
                  <_components.span>{s.braleSupported}</_components.span>
                </_components.div> : <FontAwesomeIcon className="h-6 w-6 text-gray-300 dark:text-gray-700 align-middle" icon={faHyphen} />}
            </_components.td>
          </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"Blockchain token standards vary in their design and functionality. Some, like the ERC-20 standard, provide a common interface that offers great flexibility but generally requires more effort to implement. Others, like Solana's SPL Token Standard, integrate the token implementation into the blockchain itself, simplifying the issuance process while introducing certain limitations."}</_components.p>{"\n"}<_components.h2>{"Bringing native stablecoins to emerging ecosystems"}</_components.h2>{"\n"}<_components.p>{"We've had the opportunity to speak with many emerging ecosystems about bringing native stablecoins to their network. The time to implement an Ethereum or Solana-compatible blockchain is less than a week, and typically a month to implement other standards."}</_components.p>{"\n"}<_components.p>{"Once implemented, stablecoins have onramps and offramps built-in, and leverage the same technology, treasury management, and transparency backing stablecoins on 11 blockchains today."}</_components.p>{"\n"}<_components.p>{"We're excited to partner with emerging ecosystems to increase access to stablecoins. To learn more, please reach out to our team."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "stablecoin-token-standards-on-leading-blockchains.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    